export const trackMetaEvent = (eventName, data = {}) => {
  if (window.fbq) {
    window.fbq("track", eventName, data);
  }
};